import React from "react";
import {Tooltip as AntdTooltip} from "antd";
import {overlayInnerStyle} from "./Tooltip.style";

const defaultTrigger = ['click', 'hover']

const Tooltip = props => {
    const {
        title,
        placement,
        children
    } = props;

    return (<AntdTooltip
        placement={placement || 'top'}
        title={title}
        trigger={defaultTrigger}
        overlayStyle={{'ant-tooltip-arrow': {opacity: 0}}}
        overlayInnerStyle={overlayInnerStyle}
        align={{offset: [0, '7px']}}
    >
        {children}
    </AntdTooltip>);
}

export default Tooltip;
